const tips = [
    {   
        id: "001",
        Dx: 4,
        Msg: "Create a rationing plan in the event of a water shortage. Store up to 1 gallon per person per day for drinking and sanitation",
    },
    {
        id: "002",
        Dx: 4,
        Msg: "Droughts increase the risk of wildfires. Use extreme caution when dealing with outdoor burning, such as fire pits and grilling.",
    },
    {
        id: "003",
        Dx: 4,
        Msg: "Stop watering your lawn and let it go dormant. Don’t worry — it’ll revive itself next season!",
    },
    {
        id: "004",
        Dx: 3,
        Msg: "Store drinking water in the refrigerator. Do not let the tap run while you are waiting for water to cool.",
    },
    {
        id: "005",
        Dx: 3,
        Msg: "Place a bucket in the shower to catch excess water for watering plants.",
    },
    {
        id: "006",
        Dx: 3,
        Msg: "Avoid letting the water run while brushing your teeth, washing your face or shaving.",
    },
    {
        id: "007",
        Dx: 2,
        Msg: "Take short showers instead of baths. Turn on the water only to get wet and lather and then again to rinse off.",
    },
    {
        id: "008",
        Dx: 2,
        Msg: "Avoid flushing the toilet unnecessarily. Dispose of tissues, insects and other similar waste in the trash rather than the toilet.",
    },
    {
        id: "009",
        Dx: 2,
        Msg: "Hand wash dishes by filling two containers—one with soapy water and the other with rinse water containing a small amount of chlorine bleach.",
    },
    {
        id: "010",
        Dx: 2,
        Msg: "Avoid using running water to thaw meat or other frozen foods. Defrost food overnight in the refrigerator or use the defrost setting on your microwave.",
    },
    {
        id: "011",
        Dx: 1,
        Msg: "Instead of using the garbage disposal, throw food in the garbage or start a compost pile to dispose it.",
    },
    {
        id: "012",
        Dx: 1,
        Msg: "Never pour water down the drain when there may be another use for it. For example, use it to water your indoor plants or garden.",
    },
    {
        id: "013",
        Dx: 1,
        Msg: "Install a toilet displacement device to cut down on the amount of water needed to flush. Place a one-gallon plastic jug of water into the tank to displace toilet flow. Make sure it does not interfere with the operating parts.",
    },
    {
        id: "014",
        Dx: 0,
        Msg: "Fix dripping faucets by replacing washers. One drop per second wastes 2,700 gallons of water a year.",
    },
    {
        id: "015",
        Dx: 0,
        Tip: "Check all plumbing for leaks and have any leaks repaired by a plumber.",
    },
    {
        id: "016",
        Dx: 0,
        Tip: "Retrofit all household faucets by installing aerators with flow restrictors.",
    },
    {
        id: "017",
        Dx: 0,
        Tip: "Install an instant hot water heater on your sink.",
    },
    {
        id: "018",
        Dx: 0,
        Tip: "Replace your showerhead with an ultra-low-flow version.",
    },

]

module.exports.tips = tips;